import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientPageSectionModel } from '../../domain/models/dynamic-form-schema.model';
import { FormPage } from '../../domain/models/form-page.enum';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root'
})
export class DynamicFormApiService {
    constructor(private apiService: ApiService) {}

    getFormSections(page: FormPage): Observable<ClientPageSectionModel[]> {
        let params = new HttpParams();
        if (page) params = params.set('applicationPageNumber', page.toString());

        return this.apiService.get(
            `/clients/${runtimeConfig.clientId}/dynamic-form`,
            params
        );
    }
}
